import { Box } from '@mui/material'
import { DetailKeyValue } from '../../../../../../components'
import { NoResponse } from '../../../../../../components/errors/noResponse'
import { useTranslation } from 'react-i18next'
import { Section } from '../section'
import { ItemDetail } from '../../type'
import { icons } from '../../../../../../utils/icons'
import { useStyles } from './styles'

export type ItemsSectionProps = {
  items?: ItemDetail[]
  scrollable?: boolean
}

function ItemsSection({ items, scrollable }: ItemsSectionProps) {
  const { t } = useTranslation()
  const styles = useStyles()

  return (
    <Section icon={icons('list')} title={t('actionPlan.sections.items')} scrollable={scrollable} minHeaderHeight={67}>
      <Box sx={styles.container}>
        {!!items?.length && items.map((item) => (
          <DetailKeyValue
            key={item.id}
            sxContainer={styles.detailItem}
            value={item.answer}
            caption={item.question}
          />
        ))}

        {!items?.length && <NoResponse label={t('reportFolio.detail.general.noInformation')} />}
      </Box>
    </Section>
  )
}

export { ItemsSection }
